class MiniMeSpeechBubble {
	constructor(svgDoc) {
		this.svgDoc = svgDoc;
		this.currentBubble = null;
		this.timeoutId = null;
	}

	show(bubble, durationMs = 10000) {
		this.dismiss();
		this.currentBubble = document.createElementNS("http://www.w3.org/2000/svg", "image");
		this.currentBubble.setAttribute("x", bubble.x);
		this.currentBubble.setAttribute("y", bubble.y);
		this.currentBubble.setAttribute("width", bubble.width);
		this.currentBubble.setAttribute("height", bubble.height);
		this.currentBubble.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", bubble.src);
		this.currentBubble.setAttribute("style", "opacity:0");
		this.svgDoc.appendChild(this.currentBubble);
		gsap.to(this.currentBubble, { opacity: 1, duration: 0.5 });
		this.timeoutId = window.setTimeout(() => this.dismiss(), durationMs);
	}

	dismiss() {
		if (!this.currentBubble) {
			return;
		}
		clearTimeout(this.timeoutId);
		const bubble = this.currentBubble;
		this.currentBubble = null;
		this.timeoutId = null;
		gsap.to(bubble, {
			opacity: 0,
			duration: 0.5,
			onComplete: () => {
				bubble.style.display = "none";
			}
		});
	}
}
